
import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { Rodeo } from '../../../../../model/rodeo';
import { Team } from '../../../../../model/team';

@Component({
    selector: 'team-popup',
    templateUrl: 'team-popup.html'
})
export class TeamPopupModal {
    rodeo: Rodeo;
    team: Team;
    editing: boolean = true;

    rounds: any[];

    constructor(navParams: NavParams, private viewController: ViewController) {
        this.rodeo = navParams.get('rodeo');
        this.team = navParams.get('team');

        if (!this.team) {
            this.team = new Team();
            this.editing = false;
        }
    }

    create() {
        this.viewController.dismiss(this.team);
    }

    remove() {
        this.viewController.dismiss(0);
    }

    cancel() {
        this.viewController.dismiss(null);
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/results/teams/team-popup.ts